/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [

        {
            // =============================================================================
            // MAIN LAYOUT ROUTES
            // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                // =============================================================================
                // Theme Routes
                // =============================================================================
                {
                    path: '/',
                    redirect: '/users'
                },
                {
                    path: '/terminals',
                    name: 'terminals',
                    component: () => import('./views/Terminal/Terminals')
                },
                {
                    path: '/terminal/:id',
                    name: 'terminal',
                    component: () => import('./views/Terminal/Terminal')
                },
                {
                    path: '/access_groups',
                    name: 'access_groups',
                    component: () => import('./views/AccessGroup/AccessGroups')
                },
                {
                    path: '/access_group/:id',
                    name: 'access_group',
                    component: () => import('./views/AccessGroup/AccessGroup')
                },
                {
                    path: '/users',
                    name: 'users',
                    component: () => import('./views/User/Users')
                },
                {
                    path: '/user/:id',
                    name: 'user',
                    component: () => import('./views/User/User')
                },
                {
                    path: '/accesses',
                    name: 'accesses',
                    component: () => import('./views/Access/AllAccesses')
                }
            ]
        },
        // =============================================================================
        // FULL PAGE LAYOUTS
        // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
                // =============================================================================
                // PAGES
                // =============================================================================
                {
                    path: '/login',
                    name: 'page-login',
                    component: () => import('@/views/pages/Login.vue')
                },
                {
                    path: '/pages/error-404',
                    name: 'page-error-404',
                    component: () => import('@/views/pages/Error404.vue')
                }
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ]
})

router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = 'none'
    }
})

router.beforeEach((to, from, next) => {
    if (!store.getters.loggedIn && to.path !== '/login') {
        return next('/login')
    }

    if (to.meta.permission && store.getters.userData) {
        if (store.getters.permissions.includes(to.meta.permission)) {
            return next()
        } else {
            return next(false)
        }
    }

    next()
})

export default router
